import React, { Component, Fragment } from "react";
import Grid from "../../Utils/Grid";
import { reduxForm, Field } from "redux-form";
import Title from "../../Utils/Headers/Title";
import { HUMAN_RESOURCES, ROLE_ADMIN, ROLE_ADMIN_STATION, FIREFIGHTER_TYPE, GENDER, SYSTEM_STATUS_FILTER } from "../../../../utility/constants";
import { standardActions } from "../../Utils/Grid/StandardActions";
import { renderNumber, SelectField } from "../../Utils/renderField/renderField";
import OrderSearchComponent from "../../Utils/OrderSearch/orderSearch";
import DownloadButton from "../../Utils/DownloadButton/DownloadButton";
import { api } from "api";
import { canCreate, canEdit, canDelete, MODULES } from "../../../../utility/permissions";
import Swal from 'sweetalert2';
import './users-list.css';

class List extends Component {
    componentDidMount() {
        this.props.customUserList();
        this.props.stationFilterList(true);
        this.props.changeValueSelectUserStation();
    }

    render() {
        const {
            customUserList,
            me,
            data,
            page,
            eliminar,
            loader,
            filterByRole,
            onSortChange,
            filterByStation,
            searchCustomChange,
            filterByFirefighterType,
            filterByStatus,
        } = this.props;

        const selects = [
            {
                title: "Estación",
                name: "station",
                data: this.props.station.filter_list && this.props.station.filter_list.length > 0 ?
                    this.props.station.filter_list.map(item => item.label === 'Todos' ? { ...item, label: 'Todas las Estaciones' } : item)
                    : [],
                funcion: filterByStation,
            },
            {
                title: "Rol",
                name: "role",
                data:
                    [{ label: 'Todos los Roles', value: '' },
                    { label: 'Administrador', value: 1 },
                    { label: 'Comandante', value: 5 },
                    { label: 'Jefe de Servicio', value: 7 },
                    { label: 'Cabinista', value: 8 },
                    { label: 'Bombero', value: 10 },
                    { label: "Recursos Humanos", value: 11 }
                    ],
                funcion: filterByRole,
            },
            {
                title: "Tipo de Bombero",
                name: "firefighter_type",
                data: [{ label: 'Todos los Tipos', value: '' }, ...FIREFIGHTER_TYPE],
                funcion: filterByFirefighterType,
            },
            {
                title: "Sexo",
                name: "gender",
                data: [{ label: 'Todos los Géneros', value: '' }, ...GENDER],
                funcion: this.props.filterByGender,
            },
            {
                title: "Estado",
                name: "status",
                data: SYSTEM_STATUS_FILTER,
                funcion: filterByStatus,
            },
        ];

        const columns = [
            {
                dataField: "ids",
                text: "ID",
                sort: true,
                headerClasses: "col-1",
                formatter: (cell, row) => {
                    return <span>#{row.id}</span>;
                },
            },
            {
                dataField: "first_name",
                text: "Nombre",
                sort: true,
                formatter: (cell, row) => `${cell} ${row.last_name}`,
            },
            {
                dataField: "station",
                text: "Estacion",
                sort: true,
                headerClasses: "d-none d-md-table-cell",
                classes: "d-none d-md-table-cell",
                formatter: (cell) => (cell ? `${cell.name}` : ""),
            },
            {
                dataField: "address",
                text: "Dirección",
                sort: true,
                headerClasses: "d-none d-md-table-cell",
                classes: "d-none d-md-table-cell",
            },
            {
                dataField: "phone_number",
                headerClasses: "col-1 d-none d-md-table-cell",
                classes: "d-none d-md-table-cell",
                text: "Teléfono",
                sort: true,
            },
            {
                dataField: "email",
                text: "Correo",
                sort: true,
                headerClasses: "d-none d-md-table-cell",
                classes: "d-none d-md-table-cell",
            },
            {
                dataField: "id",
                text: "Acciones",
                headerClasses: "text-center",
                classes: "text-center",
                formatter: (cell, row) => {
                    const canEditPerm = canEdit(this.props.me, MODULES.USERS);
                    const canDeletePerm = canDelete(this.props.me, MODULES.USERS);

                    return (
                        <div className="users-action-buttons justify-content-center">
                            <a
                                href={`#/users/${cell}`}
                                className="users-action-btn users-btn-view"
                                title="Ver"
                            >
                                <span className="material-icons">visibility</span>
                            </a>
                            {canEditPerm && (
                                <React.Fragment>
                                    <a
                                        href={`#/users/${cell}/editar`}
                                        className="users-action-btn users-btn-edit"
                                        title="Editar"
                                    >
                                        <span className="material-icons">edit</span>
                                    </a>
                                </React.Fragment>
                            )}

                            {/* {canDeletePerm && (
                                <button
                                    onClick={() => eliminar(cell)}
                                    className="users-action-btn users-btn-delete"
                                    title="Eliminar"
                                >
                                    <span className="material-icons">delete</span>
                                </button>
                            )} */}
                            {canEditPerm && (
                                <React.Fragment>
                                    <a
                                        href={`#/users/${cell}/permissions`}
                                        className="users-action-btn users-btn-permissions"
                                        title="Permisos"
                                    >
                                        <span className="material-icons">lock</span>
                                    </a>
                                    <button
                                        onClick={() => {
                                            Swal.fire({
                                                title: '¿Restablecer contraseña?',
                                                text: "Se generará una nueva contraseña y se obligará al usuario a cambiarla.",
                                                icon: 'warning',
                                                showCancelButton: true,
                                                confirmButtonColor: '#3085d6',
                                                cancelButtonColor: '#d33',
                                                confirmButtonText: 'Sí, restablecer!'
                                            }).then((result) => {
                                                if (result.isConfirmed) {
                                                    api.post(`user/${cell}/reset_password_admin`).then((response) => {
                                                        Swal.fire(
                                                            'Restablecida!',
                                                            `${response.detail}<br/><br/>Nueva contraseña temporal: <b>${response.new_password}</b>`,
                                                            'success'
                                                        )
                                                    }).catch((error) => {
                                                        Swal.fire('Error', 'No se pudo restablecer', 'error');
                                                    });
                                                }
                                            });
                                        }}
                                        className="users-action-btn users-btn-reset"
                                        title="Restablecer Contraseña"
                                    >
                                        <span className="material-icons">vpn_key</span>
                                    </button>
                                </React.Fragment>
                            )}
                        </div>
                    );
                },
            },
        ];

        const rowClasses = (row, rowIndex) => {
            if (row.status === 1) {
                return 'row-class-danger parpadea';
            }
            return '';
        };

        return (
            <div className="users-page-container">
                {/* Page Header */}
                <div className="users-page-header">
                    <div className="users-page-title-section">
                        <h1>Usuarios</h1>
                        <p>Listado General De Usuarios</p>
                    </div>
                    {canCreate(me, MODULES.USERS) && (
                        <a href="/#/users/create" className="users-create-btn">
                            <span className="material-icons">add_circle</span>
                            Crear Usuario
                        </a>
                    )}
                </div>

                {/* Filters Section */}
                <div className="users-filters-section">
                    {/* First Row: Main Filters */}
                    <div className="row">
                        {/* Estación Filter */}
                        <div className="col-lg-2 col-md-4 col-sm-6 mb-3">
                            <div className="users-filter-with-icon">
                                <span className="material-icons filter-icon">filter_alt</span>
                                <Field
                                    name="station"
                                    component={SelectField}
                                    options={
                                        this.props.station.filter_list && this.props.station.filter_list.length > 0
                                            ? this.props.station.filter_list.map(item => item.label === 'Todos' ? { ...item, label: 'Todas las Estaciones' } : item)
                                            : []
                                    }
                                    isSearchable={true}
                                    placeholder="Todas las Estaciones"
                                    customChange={filterByStation}
                                />
                            </div>
                        </div>

                        {/* Estado Filter */}
                        <div className="col-lg-2 col-md-4 col-sm-6 mb-3">
                            <div className="users-filter-with-icon">
                                <span className="material-icons filter-icon">filter_alt</span>
                                <Field
                                    name="status"
                                    component={({ input, meta, ...rest }) => (
                                        <select
                                            {...input}
                                            className="form-control"
                                            onChange={(e) => {
                                                input.onChange(e);
                                                filterByStatus(e.target.value);
                                            }}
                                        >
                                            {SYSTEM_STATUS_FILTER.map((opt, idx) => (
                                                <option key={idx} value={opt.value}>{opt.label}</option>
                                            ))}
                                        </select>
                                    )}
                                />
                            </div>
                        </div>

                        {/* Rol Filter */}
                        <div className="col-lg-2 col-md-4 col-sm-6 mb-3">
                            <div className="users-filter-with-icon">
                                <span className="material-icons filter-icon">filter_alt</span>
                                <Field
                                    name="role"
                                    component={({ input, meta, ...rest }) => (
                                        <select
                                            {...input}
                                            className="form-control"
                                            onChange={(e) => {
                                                input.onChange(e);
                                                filterByRole(e.target.value);
                                            }}
                                        >
                                            <option value="">Todos los roles</option>
                                            <option value="1">Administrador</option>
                                            <option value="5">Comandante</option>
                                            <option value="7">Jefe de Servicio</option>
                                            <option value="8">Cabinista</option>
                                            <option value="10">Bombero</option>
                                            <option value="11">Recursos Humanos</option>
                                        </select>
                                    )}
                                />
                            </div>
                        </div>

                        {/* Tipo de Bombero Filter */}
                        <div className="col-lg-2 col-md-4 col-sm-6 mb-3">
                            <div className="users-filter-with-icon">
                                <span className="material-icons filter-icon">filter_alt</span>
                                <Field
                                    name="firefighter_type"
                                    component={({ input, meta, ...rest }) => (
                                        <select
                                            {...input}
                                            className="form-control"
                                            onChange={(e) => {
                                                input.onChange(e);
                                                filterByFirefighterType(e.target.value);
                                            }}
                                        >
                                            <option value="">Todos los tipos</option>
                                            {FIREFIGHTER_TYPE.map((opt, idx) => (
                                                <option key={idx} value={opt.value}>{opt.label}</option>
                                            ))}
                                        </select>
                                    )}
                                />
                            </div>
                        </div>

                        {/* Sexo Filter */}
                        <div className="col-lg-2 col-md-4 col-sm-6 mb-3">
                            <div className="users-filter-with-icon">
                                <span className="material-icons filter-icon">filter_alt</span>
                                <Field
                                    name="gender"
                                    component={({ input, meta, ...rest }) => (
                                        <select
                                            {...input}
                                            className="form-control"
                                            onChange={(e) => {
                                                input.onChange(e);
                                                this.props.filterByGender(e.target.value);
                                            }}
                                        >
                                            <option value="">Todos los géneros</option>
                                            {GENDER.map((opt, idx) => (
                                                <option key={idx} value={opt.value}>{opt.label}</option>
                                            ))}
                                        </select>
                                    )}
                                />
                            </div>
                        </div>

                        {/* Search Input */}
                        <div className="col-lg-2 col-md-4 col-sm-6 mb-3">
                            <input
                                type="text"
                                className="form-control users-search-input"
                                placeholder="Buscar..."
                                onChange={(e) => searchCustomChange(e.target.value)}
                            />
                        </div>
                    </div>

                    {/* Second Row: Age Filters and Export Button */}
                    <div className="row">
                        <div className="col-lg-2 col-md-4 col-sm-6 mb-3">
                            <div className="users-filter-with-icon">
                                <span className="material-icons filter-icon">filter_alt</span>
                                <Field
                                    name="age_min"
                                    component={renderNumber}
                                    placeholder="Edad mínima"
                                    onChange={(e) => this.props.filterByAgeMin(e && e.target ? e.target.value : e)}
                                    className="form-control"
                                />
                            </div>
                        </div>

                        <div className="col-lg-2 col-md-4 col-sm-6 mb-3">
                            <div className="users-filter-with-icon">
                                <span className="material-icons filter-icon">filter_alt</span>
                                <Field
                                    name="age_max"
                                    component={renderNumber}
                                    placeholder="Edad máxima"
                                    onChange={(e) => this.props.filterByAgeMax(e && e.target ? e.target.value : e)}
                                    className="form-control"
                                />
                            </div>
                        </div>

                        <div className="col-lg-2 col-md-4 col-sm-6 mb-3">
                            <button
                                className="users-export-btn w-100"
                                onClick={this.props.downloadExcel}
                                disabled={this.props.excelLoading}
                            >
                                <span className="material-icons">description</span>
                                Exportar Excel
                            </button>
                        </div>
                    </div>
                </div>

                {/* Table */}
                <div className="users-table-card">
                    <Grid
                        data={data}
                        loading={loader}
                        page={page}
                        columns={columns}
                        rowClass={rowClasses}
                        onSortChange={onSortChange}
                        onPageChange={customUserList}
                        noDataMessage={"Sin Usuarios"}
                    />
                </div>
            </div>
        );
    }
}

export default reduxForm({
    form: "ListUsers",
})(List);
